var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "deliverable-dates project-dates" },
    [
      _c("div", { staticClass: "deliverable-dates__started" }, [
        _c("strong", { staticClass: "dates-title" }, [_vm._v("STARTED")]),
        _c("br"),
        _vm._v(" "),
        _c("span", { staticClass: "dates-value" }, [
          _vm._v(
            _vm._s(
              _vm._f("moment")(
                _vm.deliverable.created_at,
                "DD MMM, YYYY @ H:mm"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "deliverable-dates__status" }, [
        _c("strong", { staticClass: "dates-title" }, [_vm._v("DUE ON")]),
        _c("br"),
        _vm._v(" "),
        _vm.deliverable.due_date
          ? _c("span", { staticClass: "dates-value" }, [
              _vm._v(
                _vm._s(
                  _vm._f("moment")(_vm.deliverable.due_date, "DD MMM, YYYY")
                )
              )
            ])
          : _c("span", { staticClass: "dates-value" }, [_vm._v("Not Set")])
      ]),
      _vm._v(" "),
      _c("ProjectColor", { attrs: { project: _vm.deliverable } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }